module.exports = __webpack_public_path__ + "static/media/plumsteadWestThamesmead.ce0cfc08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/plumsteadWestThamesmead.jpg
// module id = 297
// module chunks = 0